<page-heading
  [title]="(('task.detail.title' | translate) + ' - ' + (task?.name || ''))"
  [description]="'task.detail.description' | translate"
  [hasBreadcrumb]="true"
  [breadcrumb]="breadcrumb"
/>

<div class="row g-2">
  <div class="col-xs-12 col-lg-7">
    <div class="card h-70">
      <div class="card-body">
        <div
          class="d-flex align-items-center justify-content-between position-relative"
        >
          <div class="mb-4">
            <span class="position-relative d-inline-block align-middle">
              <span class="h2 fw-bold mb-0 d-inline-block">
                {{ task?.name }}
              </span>
              <span
                class="badge font-14 position-absolute top-50 start-100 translate-middle-y ms-2 text-uppercase"
                [ngClass]="{
                  'bg-warning': task?.priority === 'HIGH',
                  'bg-primary': task?.priority === 'MEDIUM',
                  'bg-secondary': task?.priority === 'LOW',
                  'bg-danger': task?.priority === 'URGENT'
                }"
              >
                {{ translateEnuns($safeNavigationMigration(task?.priority)) | translate }}
              </span>
            </span>
          </div>
          <div class="dropdown card-widgets mt-2 position-absolute top-0 end-0">
            <a
              href="#"
              class="dropdown-toggle arrow-none"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i class="uil uil-ellipsis-h"></i>
            </a>
            <div class="dropdown-menu dropdown-menu-end">
              <!-- <a href="javascript:void(0);" class="dropdown-item">
                <i class="uil uil-user-plus me-1"></i>Atribuir Usuário
              </a> -->
              <a
                href="javascript:void(0);"
                class="dropdown-item"
                (click)="goToEditTask()"
              >
                <i class="uil uil-edit me-1"></i>{{ 'task.detail.edit' | translate }}
              </a>
              <div class="dropdown-divider"></div>
              <a
                href="javascript:void(0);"
                class="dropdown-item text-danger"
                (click)="removeTask()"
              >
                <i class="uil uil-trash-alt me-1"></i>{{ 'task.detail.remove' | translate }}
              </a>
            </div>
          </div>
        </div>

        <div>
          <div class="row my-3 gaap-3">
            <div class="col-4">
              <p class="mt-2 mb-1 text-muted fw-bold font-12 text-uppercase">
                {{ 'task.detail.creationDate' | translate }}
              </p>
              <div class="d-flex mt-2">
                <i class="uil uil-schedule font-18 text-success me-1"></i>
                <div>
                  <h5 class="mt-1 font-14">
                    {{
                      $safeNavigationMigration(task?.createdAt)
                        | timezoneDate
                          : "DD/MM/YYYY - HH:mm"
                          : getTimezoneCompanyCurrentUser()
                    }}
                  </h5>
                </div>
              </div>
            </div>
            <div class="col-4">
              <p class="mt-2 mb-1 text-muted fw-bold font-12 text-uppercase">
                {{ 'task.detail.dueDate' | translate }}
              </p>
              <div class="d-flex mt-2">
                <i class="uil uil-schedule font-18 text-success me-1"></i>
                <div>
                  <h5 class="mt-1 font-14">
                    @if (task.deadlineAt) {
                      {{ task.deadlineAt | timezoneDate : deadlineFormat : getTimezoneCompanyCurrentUser() }}
                    } @else {
                      <!-- A task with no date appears in no day view: the same mark as the lists. -->
                      <span
                        class="badge campaign-badge is-neutral"
                        [matTooltip]="'task.activity.noDateHint' | translate"
                        [attr.aria-label]="'task.activity.noDateHint' | translate"
                      >
                        <i class="uil uil-calendar-slash me-1"></i>{{ 'task.activity.noDate' | translate }}
                      </span>
                    }
                    <!-- E4 RF-05: the explicit mark, never inferred from the time of day. -->
                    @if (task.untimed) {
                      <small class="text-muted d-block">{{ 'task.detail.untimed' | translate }}</small>
                    }
                  </h5>
                </div>
              </div>
            </div>
            <div class="col-4">
              <p class="mt-2 mb-1 text-muted fw-bold font-12 text-uppercase">
                {{ 'task.detail.startDate' | translate }}
              </p>
              <div class="d-flex mt-2">
                <div>
                  <h5 class="mt-1 font-14">
                    @if(task?.startDate) {
                    <i class="uil uil-schedule font-18 text-success me-1"></i>
                    {{
                      $safeNavigationMigration(task?.startDate)
                        | timezoneDate
                          : "DD/MM/YYYY - HH:mm"
                          : getTimezoneCompanyCurrentUser()
                    }}
                    } @else {
                    <span>
                      <i class="uil uil-exclamation-triangle text-warning"></i>
                      {{ 'task.detail.notStarted' | translate }}
                    </span>
                    }
                  </h5>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-14">
            <h5 class="mt-3">{{ 'task.detail.descriptionLabel' | translate }}</h5>
            <p class="text-muted">
              {{ task?.description ?? ('task.detail.noDescription' | translate) }}
            </p>
          </div>
          <div class="mt-14 d-flex align-items-center justify-content-between">
            @if(task?.status === 'DONE') {
            <div class="w-100">
              <div
                class="alert alert-success d-flex align-items-center mb-2"
                role="alert"
              >
                <i class="uil uil-check-circle font-18 me-2"></i>
                <div>
                  {{ 'task.detail.completedSuccessfully' | translate }}
                  {{
                    $safeNavigationMigration(task?.completedAt)
                      | timezoneDate
                        : "DD/MM/YYYY - HH:mm"
                        : getTimezoneCompanyCurrentUser()
                  }}
                  @if (completedByName) {
                    · {{ completedByName }}
                  }
                </div>
              </div>
              <!-- E4 RF-33: a conclusion by the win carries no outcome and says so. -->
              @if (task?.concludedByWin) {
                <div class="alert alert-secondary d-flex align-items-center mb-0" role="alert">
                  <i class="uil uil-trophy font-18 me-2"></i>
                  <div>{{ 'task.detail.concludedByWin' | translate }}</div>
                </div>
              }
              <!-- E4 RF-51: concluded with the deletion of its deal — no outcome, counted nowhere. -->
              @if (task?.concludedByDealRemoval) {
                <div class="alert alert-secondary d-flex align-items-center mb-0" role="alert">
                  <i class="uil uil-trash-alt font-18 me-2"></i>
                  <div>{{ 'task.detail.concludedByDealRemoval' | translate }}</div>
                </div>
              }
            </div>
            } @else {
            <!--
              E4 RF-12, RF-17 (plan AD-03): Concluir is offered whether or not the activity was
              started; a deal activity opens the conclusion dialog, any other completes at once.
            -->
            <div class="d-flex gap-2 flex-wrap">
              @if(task?.status === 'PENDING') {
                <button
                  class="btn btn-outline-secondary d-flex align-items-center justify-content-center button-size"
                  (click)="startTask($safeNavigationMigration(task?._id))"
                >
                  @if(isStarting$ | async) {
                  <mat-spinner diameter="20"></mat-spinner>
                  } @else {
                  <i class="uil uil-play me-1"></i>{{ 'task.detail.startTask' | translate }} }
                </button>
              }
              @if(canConclude) {
                <button
                  class="btn btn-primary d-flex align-items-center justify-content-center button-size"
                  (click)="conclude()"
                >
                @if(isCompleting$ | async) {
                  <mat-spinner diameter="20"></mat-spinner>
                } @else {
                  <i class="uil uil-check me-1"></i>{{ 'task.detail.completeTask' | translate }} }
                </button>
              }
              @if(canPostpone) {
                <button
                  class="btn btn-outline-primary d-flex align-items-center justify-content-center button-size"
                  (click)="postpone()"
                >
                  <i class="uil uil-calendar-alt me-1"></i>{{ 'task.detail.postponeTask' | translate }}
                </button>
              }
            </div>
            }
          </div>

          <!-- E4 validation N2: the deal is outside the user's visibility — concluding and postponing are a supervisor's. -->
          @if (dealHidden && task?.status !== 'DONE') {
            <div class="alert alert-secondary d-flex align-items-center mt-2 mb-0" role="alert">
              <i class="uil uil-lock font-18 me-2"></i>
              <div>{{ 'task.activity.dealHiddenHint' | translate }}</div>
            </div>
          }

          <!-- E4 RF-09, RF-11, RF-13: what the conclusion recorded. -->
          @if (task?.outcome || task?.nextStepSkipReason) {
            <div class="mt-3">
              <h5 class="mt-3">{{ 'task.detail.outcome' | translate }}</h5>
              <div class="d-flex flex-wrap gap-2 align-items-center mb-2">
                @if (task?.outcome) {
                  <span class="badge campaign-badge is-ok">{{ outcomeLabel | translate }}</span>
                }
                @if ($safeNavigationMigration(task?.durationMinutes) !== undefined && $safeNavigationMigration(task?.durationMinutes) !== null) {
                  <span class="text-muted font-13">
                    <i class="uil uil-clock me-1"></i>{{ 'task.detail.duration' | translate }}: {{ 'task.activity.duration' | translate: { minutes: task.durationMinutes } }}
                  </span>
                }
              </div>
              @if (task?.outcomeNote) {
                <p class="text-muted fw-bold font-12 text-uppercase mb-1">{{ 'task.detail.outcomeNote' | translate }}</p>
                <p class="mb-2">{{ task.outcomeNote }}</p>
              }
              @if (task?.conclusionSnapshot?.stageName) {
                <p class="text-muted fw-bold font-12 text-uppercase mb-1">{{ 'task.detail.snapshot' | translate }}</p>
                <p class="mb-2">
                  {{ 'task.activity.snapshot' | translate: { stage: task.conclusionSnapshot.stageName } }}
                  @if (task.conclusionSnapshot?.healthBand) {
                    · {{ 'task.activity.snapshotHealth' | translate: { health: ('kanban.healthBand.' + task.conclusionSnapshot.healthBand.toLowerCase() | translate) } }}
                  }
                </p>
              }
              @if (task?.nextStepSkipReason) {
                <p class="text-muted fw-bold font-12 text-uppercase mb-1">{{ 'task.detail.skipReason' | translate }}</p>
                <p class="mb-2">{{ task.nextStepSkipReason }}</p>
              }
            </div>
          }

          <!-- E4 RF-26: every postponement, with the moment it moved from. -->
          @if (postponements.length > 0) {
            <div class="mt-3">
              <h5 class="mt-3">
                {{ 'task.detail.postponements' | translate }}
                <span class="badge bg-soft-secondary text-muted ms-1">{{ postponements.length }}</span>
              </h5>
              <ul class="list-unstyled mb-0">
                @for (item of postponements; track $index) {
                  <li class="text-muted font-13 mb-1">
                    <i class="uil uil-history me-1"></i>
                    {{ 'task.detail.postponementRow' | translate: {
                      from: item.from ? (item.from | timezoneDate: 'DD/MM/YYYY HH:mm' : getTimezoneCompanyCurrentUser()) : '—',
                      to: (item.to | timezoneDate: 'DD/MM/YYYY HH:mm' : getTimezoneCompanyCurrentUser()),
                      reason: item.reason
                    } }}
                  </li>
                }
              </ul>
            </div>
          }

          <hr />
          <!-- <div class="mt-14">
            <h5 class="mt-3">Comentários:</h5>
            <p class="text-muted">Em breve...</p>
          </div> -->
        </div>
      </div>
    </div>
  </div>
  <div class="col-xs-12 col-lg-5">
    <div class="card h-70 scroll">
      <div class="card-body">
        <div class="mb-3 border p-2 rounded">
          <h5
            class="m-0 py-2 px-1"
            role="button"
            data-bs-toggle="collapse"
            [attr.data-bs-target]="'#information-collapse'"
            aria-expanded="false"
            [attr.aria-controls]="'information-collapse'"
          >
            <span class="d-inline-flex align-items-center gap-1">
              <i class="uil uil-angle-down font-18"></i>
              {{ 'task.detail.additionalInformation' | translate }}
            </span>
          </h5>
          <div class="collapse show" id="information-collapse">
            <div
              class="mt-3 d-flex align-items-center justify-content-between border-bottom pb-2 mb-2"
            >
              <p class="text-muted fw-bold font-12 text-uppercase mb-0">
                {{ 'task.detail.taskType' | translate }}
              </p>
              <h5 class="font-14 mb-0">
                {{ typeLabel | translate }}
              </h5>
            </div>
            <!-- E4: the deal this activity belongs to (ADR-004). -->
            @if (hasDeal) {
              <div
                class="d-flex align-items-center justify-content-between border-bottom pb-2 mb-2"
              >
                <p class="text-muted fw-bold font-12 text-uppercase mb-0">
                  {{ 'task.detail.deal' | translate }}
                </p>
                @if (dealRemoved) {
                  <!-- E4 RF-52: the deal was deleted — said, not linked; the activity is one with no deal. -->
                  <span class="badge campaign-badge is-neutral">
                    <i class="uil uil-trash-alt me-1"></i>{{ 'task.detail.dealRemoved' | translate }}
                  </span>
                } @else if (dealHidden) {
                  <!-- Said, never shown (RF-44): the deal is outside the user's visibility. -->
                  <span
                    class="badge campaign-badge is-warn"
                    [matTooltip]="'task.activity.dealHiddenHint' | translate"
                    [attr.aria-label]="'task.activity.dealHiddenHint' | translate"
                  >
                    <i class="uil uil-lock me-1"></i>{{ 'task.activity.dealHidden' | translate }}
                  </span>
                } @else {
                  <a href="javascript:void(0);" class="font-14 mb-0 fw-semibold" (click)="goToDeal()">
                    {{ dealName }}
                  </a>
                }
              </div>
            }
            <div
              class="d-flex align-items-center justify-content-between border-bottom pb-2 mb-2"
            >
              <p
                class="text-muted fw-bold font-12 text-uppercase text-uppercase mb-0"
              >
                {{ 'task.detail.responsible' | translate }}
              </p>
              <div class="d-flex mt-2">
                @if(task?.user) {
                <img
                  [src]="$safeNavigationMigration(task?.user?.image)"
                  [alt]="$safeNavigationMigration(task?.user?.name)"
                  class="img-fluid avatar-xs rounded-circle"
                  (error)="onImageError($event)"
                />
                <div class="ms-2">
                  <h5 class="mt-1 font-14">
                    {{ task?.user?.name }}
                  </h5>
                </div>
                } @else {
                <h5 class="font-14 mb-0">{{ 'task.detail.noResponsible' | translate }}</h5>
                }
              </div>
            </div>
            <div
              class="d-flex align-items-center justify-content-between border-bottom pb-2 mb-2"
            >
              <p
                class="text-muted fw-bold font-12 text-uppercase text-uppercase mb-0"
              >
                {{ 'task.detail.taskStatus' | translate }}
              </p>
              <h5
                class="badge font-14 mb-0 text-uppercase"
                [ngClass]="{
                  'bg-warning': task?.status === 'PENDING',
                  'bg-info': task?.status === 'IN_PROGRESS',
                  'bg-success': task?.status === 'DONE'
                }"
              >
                {{ translateEnuns($safeNavigationMigration(task?.status)) | translate }}
              </h5>
            </div>
            <div
              class="d-flex align-items-center justify-content-between border-bottom pb-2 mb-2"
            >
              <p class="text-muted fw-bold font-12 text-uppercase mb-0">
                {{ 'task.detail.createdBy' | translate }}
              </p>
              <div class="d-flex mt-2">
                @if(task?.owner) {
                <img
                  [src]="getOwnerUserImage($safeNavigationMigration(task?.owner))"
                  [alt]="getOwnerUserName($safeNavigationMigration(task?.owner))"
                  class="img-fluid avatar-xs rounded-circle"
                  (error)="onImageError($event)"
                />
                <div class="ms-2">
                  <h5 class="mt-1 font-14">
                    {{ getOwnerUserName($safeNavigationMigration(task?.owner)) }}
                  </h5>
                </div>
                }
              </div>
            </div>
          </div>
        </div>
        <div class="border p-2 rounded">
          <h5
            class="m-0 py-2 px-1"
            role="button"
            data-bs-toggle="collapse"
            [attr.data-bs-target]="'#attachments-collapse'"
            aria-expanded="false"
            [attr.aria-controls]="'attachments-collapse'"
          >
            <span class="d-inline-flex align-items-center gap-1">
              <i class="uil uil-angle-down font-18"></i>
              {{ 'task.detail.attachments' | translate }}
            </span>
          </h5>
          <div class="collapse" id="attachments-collapse">
            <div class="dropzone-previews" id="file-previews"></div>
            @if(task?.attachments.length > 0) {
            <div class="scroll attachment-container p-1 bg-light">
              @for (file of task?.attachments; track $index) {
              <div class="card mt-1 mb-0 shadow-none border">
                <div class="p-2">
                  <div class="row align-items-center">
                    <div class="col-auto">
                      <i class="uil uil-file-alt font-24 text-primary"></i>
                    </div>
                    <div class="col ps-0">
                      <a class="text-muted fw-bold text-truncate">
                        {{ file.filename }}
                      </a>
                      <p class="small mb-0">{{ formatBytes(file.size) }}</p>
                    </div>
                  </div>
                </div>
              </div>
              }
            </div>
            } @else {
            <p class="text-muted">{{ 'task.detail.noAttachments' | translate }}</p>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
